// The scoring block: 5 weighted criteria (0–10) + the 8-item fatal checklist, laid out as
// the mockup's section cards. Shared by "Yeni Değerlendirme" and the objection-revision
// form, so a revised score is entered against exactly the same model as the original.

import type { Criterion, CriticalRule } from '../types';
import { Check, CodeTile, Icon, ScorePicker } from '../ui';

export default function ScoreForm({ criteria, rules, scores, criticals, onScore, onCritical }: {
  criteria: Criterion[];
  rules: CriticalRule[];
  scores: Record<string, number | null>;
  criticals: string[];
  onScore: (key: string, value: number) => void;
  onCritical: (key: string, checked: boolean) => void;
}) {
  return (
    <>
      <div className="callout accent">
        <Icon name="rule" />
        <span>
          <b>QMS puanlama modeli · 5 kriter, toplam 100 ağırlık puanı.</b>
          {' '}Her kriter 0–10 arası puanlanır ve ağırlığına göre toplam puana katılır.
          Kritik hata listesinden bir madde işaretlenirse çağrı, diğer puanlardan bağımsız olarak 0 alır.
        </span>
      </div>

      <section className="panel">
        <div className="sec-hd">
          <CodeTile>%100</CodeTile>
          <div style={{ minWidth: 0 }}>
            <div className="nm">Kriter puanları</div>
            <div className="sub">Her satır 0–10 · ağırlık toplam puana yansır</div>
          </div>
        </div>
        <div className="sec-body">
          {criteria.map((c) => (
            <div className="item" key={c.key}>
              <div className="item-txt">
                <span>{c.label}</span>
                <span className="w" translate="no">%{c.weight}</span>
                {c.hint ? <div className="item-hint">{c.hint}</div> : null}
              </div>
              <ScorePicker value={scores[c.key] ?? null} onChange={(v) => onScore(c.key, v)} />
            </div>
          ))}
        </div>
      </section>

      <section className="panel">
        <div className="sec-hd">
          <CodeTile kind="bad"><Icon name="warning" style={{ fontSize: 17 }} /></CodeTile>
          <div style={{ minWidth: 0 }}>
            <div className="nm">Kritik Hata (Fatal) Listesi</div>
            <div className="sub">İşaretlenen her madde çağrıyı doğrudan 0 puan yapar.</div>
          </div>
          {criticals.length ? <span className="sec-score" style={{ color: 'var(--bad)' }}>{criticals.length}</span> : null}
        </div>
        <div className="critlist">
          {rules.map((r) => (
            <div className="critline" key={r.key}>
              <Check crit checked={criticals.includes(r.key)} onChange={(on) => onCritical(r.key, on)}>
                {r.label}
                <span className="tag bad" style={{ marginLeft: 8 }}>Kritik</span>
              </Check>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
